
      import API from "!../demo_app/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../demo_app/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../demo_app/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../demo_app/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../demo_app/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../demo_app/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../demo_app/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./linked-bundle-node.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../demo_app/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./linked-bundle-node.css";
       export default content && content.locals ? content.locals : undefined;
